const snackbarState = {
  snackbarText: "",
  snackbarVisible: false,
};

const snackbarActions = {
  showSnackbar(store, text) {
    store.commit('snackbarSetText', text);
    setTimeout(() => store.commit('hideSnackbar'), 1000);
  },
};


const snackbarGetters = {

};

const snackbarMutations = {
  snackbarSetText(state, text) {
    state.snackbarText = text;
    state.snackbarVisible = true;
  },
  hideSnackbar(state) {
    state.snackbarVisible = false;
  }
};

export {
  snackbarActions,
  snackbarGetters,
  snackbarState,
  snackbarMutations
};
